import { Injectable } from '@angular/core';

@Injectable()
export class UserDataService {
    private userData;
    
    setUserData(user) {
        this.userData = user;
    }
    getUserData() {
        return this.userData;
    }

}